import { useEffect } from "react"
import { useAuthStore } from "@/features/auth/useAuthStore"
import { ACTIVITY_EVENTS, createActivityReporter } from "./activityReporter"

/** Unsichtbar: haengt Eingabe-Listener an das Fenster, solange jemand angemeldet ist. */
export function ActivityReporter() {
  const token = useAuthStore((s) => s.token)
  useEffect(() => {
    if (!token) return
    const report = createActivityReporter({
      getToken: () => useAuthStore.getState().token,
      onExpired: () => {
        try {
          sessionStorage.setItem("hh-idle-logout", "1")
        } catch {
          /* Speicher gesperrt: kein Hinweis, Abmeldung trotzdem */
        }
        useAuthStore.getState().logout()
      },
    })
    for (const ev of ACTIVITY_EVENTS) window.addEventListener(ev, report, { passive: true, capture: true })
    return () => {
      for (const ev of ACTIVITY_EVENTS) window.removeEventListener(ev, report, true)
    }
  }, [token])
  return null
}
